import { compose } from '../../../../../i18n/dictionary.js';
import { dictionary as baseDictionary } from './dictionary.js';
export const dictionary = compose(baseDictionary);
